import globalValues from '@/core/helpers/enums/globalValues';

export default class toSessionStorage {
   journeyId(value: any) {
      sessionStorage.setItem(globalValues.candidate.submissionId, value);
   }

   candidateId(value: any) {
      sessionStorage.setItem(globalValues.candidate.id, value);
   }

   stepId(value: any) {
      sessionStorage.setItem(globalValues.candidate.stepId, value);
   }

   firstName(value: string) {
      sessionStorage.setItem(globalValues.candidate.firstName, value);
   }

   lastName(value: string) {
      sessionStorage.setItem(globalValues.candidate.lastName, value);
   }
}

